import axios from 'axios';
export const client = axios.create({ baseURL: process.env.REACT_APP_LA_USINA_API_URL });
client.interceptors.request.use(config => {
  try { const token = JSON.parse(localStorage.getItem('currentUser') || 'null')?.token; if (token) config.headers.Authorization = token; } catch (_) { localStorage.removeItem('currentUser'); }
  return config;
});
client.interceptors.response.use(r => r, e => {
  if (e.response?.status === 401) { localStorage.removeItem('currentUser'); window.dispatchEvent(new Event('session-expired')); }
  const error = new Error(e.response?.data?.error || e.response?.data?.message || (e.code === 'ECONNABORTED' ? 'La operación tardó demasiado. Inténtalo de nuevo' : 'No se pudo completar la operación')); error.status = e.response?.status || 0; throw error;
});
export const getAPI = async (url, options) => (await client.get(url, options)).data;
export const postAPI = async (url, body, options) => (await client.post(url, body, options)).data;
export const putAPI = async (url, id, body) => (await client.put(`${url}/${id}`, body)).data;
export const deleteAPI = async (url, id) => (await client.delete(`${url}/${id}`)).data;
export const loginAPI = async (email, password) => {
  const data = await postAPI('login', { email, password });
  if (!data.user?.isAdmin && !data.user?.isTaquilla) throw new Error('Tu cuenta no tiene permisos de administración ni de taquilla');
  return data;
};
